"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNpsScale = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledNpsScale = _styledComponents.default.div.withConfig({
  displayName: "NpsScalestyles__StyledNpsScale",
  componentId: "sc-1hx20dq-0"
})(["text-align:center;.padded-paragraph{padding:0 ", ";@media only screen and (min-width:", "){padding:0;}}.c-nps-scale-items-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;overflow:hidden;}.c-nps-scale-rating-item{display:flex;margin:", ";&:last-child{margin-right:0;}&:before{padding:0;margin:0;list-style-type:none;content:'';}}.c-nps-scale-rating-icon{margin:", ";}.c-nps-scale-rating-scale-desc{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;padding:", ";@media only screen and (min-width:", "){padding:", " 0;}}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return "".concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " 0 0");
}, function (props) {
  return "".concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " 0 0");
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledNpsScale = StyledNpsScale;